const theme = {
  plain: {
    color: '#E6ECF1',
    backgroundColor: '#183055',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#999988',
        fontStyle: 'italic',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['string', 'attr-value'],
      style: {
        color: '#00A959',
      },
    },
    {
      types: ['punctuation', 'operator'],
      style: {
        color: '#E6ECF1',
      },
    },
    {
      types: [
        'entity',
        'url',
        'symbol',
        'number',
        'boolean',
        'variable',
        'constant',
        'property',
        'regex',
        'inserted',
      ],
      style: {
        color: '#36acaa',
      },
    },
    {
      types: ['atrule', 'keyword', 'attr-name', 'selector'],
      style: {
        color: '#ff9d3d',
      },
    },
    {
      types: ['function', 'deleted', 'tag'],
      style: {
        color: '#E6ECF1',
      },
    },
    {
      types: ['function-variable'],
      style: {
        color: '#E6ECF1',
      },
    },
    {
      types: ['tag', 'selector', 'keyword'],
      style: {
        color: '#61e3a5',
      },
    },
    {
      types: ['tag'],
      style: {
        color: '#71a7ff',
      },
    },
    {
      types: ['constant'],
      style: {
        color: '#E6ECF1',
      },
    },
  ],
};

export default theme;
